import { sanitizeReturnTo } from "@/lib/returnTo";

const KEY = "wekit_signup_coupon";

export function normalizeSignupCoupon(raw: string | null | undefined): string {
  const code = raw?.trim().toUpperCase() ?? "";
  return /^[A-Z0-9_-]{3,32}$/.test(code) ? code : "";
}

/** Keep only a code, never a price or an entitlement. Checkout validates it. */
export function storeSignupCoupon(raw: string): void {
  try {
    const code = normalizeSignupCoupon(raw);
    if (code) sessionStorage.setItem(KEY, code);
    else sessionStorage.removeItem(KEY);
  } catch { /* Callback query still carries the code if storage is unavailable. */ }
}

export function getSignupCoupon(search = ""): string {
  const params = new URLSearchParams(search);
  if (params.has("coupon")) return normalizeSignupCoupon(params.get("coupon"));
  try { return normalizeSignupCoupon(sessionStorage.getItem(KEY)); }
  catch { return ""; }
}

export function buildSignupCallback(origin: string, next: string, coupon: string): string {
  const url = new URL("/auth", origin);
  url.searchParams.set("next", sanitizeReturnTo(next));
  const code = normalizeSignupCoupon(coupon);
  if (code) url.searchParams.set("coupon", code);
  return url.toString();
}